
import HtmlContentFromApi from '@r1-frontend/ui-react/components/HtmlContentFromApi';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';

import * as ST from './styled';

export interface ICard {
    img: string,
    webpImg: string,
    isCover: boolean,
    title: string,
    description: string,
}

interface ICardProps {
    card: ICard,
    width: number,
}

const Card = ({ card, width }: ICardProps): JSX.Element => {
    const { img, webpImg, title, description, isCover } = card;
    return (<ST.CardWrapper width={width}>
        <WebpImage urlWebp={webpImg}>
            <ST.CardImage src={img} alt={title} isCover={isCover} />
        </WebpImage>
        <ST.CardContent>
            {title && <ST.CardTitle data-test={'title'}>{title}</ST.CardTitle>}
            {description && (
                <ST.CardDescription>
                    <HtmlContentFromApi>
                        {description}
                    </HtmlContentFromApi>
                </ST.CardDescription>
            )}
        </ST.CardContent>
    </ST.CardWrapper>);
};

export default Card;
